<template>
  <div>
    <router-view ref="router_view" class="pt-0" :userData="userData" :ip="ip" :categories="categories"
      :videoSections="videoSections" :c_all="c_all" :c_13="c_13" :c_20="c_20" @updateUserData="updateUserData"
      :mqttClient="mqttClient" :subscribed="subscribed" :connected="connected" @connectMQTT="connectMQTT"
      @disconnectMQTT="disconnectMQTT" @subscribeMQTT="subscribeMQTT" @unsubscribeMQTT="unsubscribeMQTT"
      @publishMQTT="publishMQTT"></router-view>

    <Footer @clickToSettings="clickToSettings"></Footer>
    <ModalSettings :show="modal_settings" @updateSettings="updateSettings" @close="modal_settings = false" />
  </div>
</template>

<script>
import Repository, { baseUrl, baseApi } from '../../repository.js';

import Footer from '@/components/Footer'
import ModalSettings from '@/components/ModalSettings';

import { userData } from '../../userData.js';
import mqtt, { MQTT } from '../../mqtt.js'

const isLocalhost = (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

export default {
  name: 'BasePage',
  components: { Footer, ModalSettings },
  data() {
    return {
      baseURL: baseUrl,
      userData: userData,
      categories: [],
      videoSections: [],
      ip: null,
      c_all: 1,
      c_13: 0,
      c_20: 0,

      modal_settings: false,

      mqttClient: null,
      subscribed: [],
      connected: false,
    }
  },
  mounted() {
    this.get_ip();
    this.get_category();
    this.get_section();

    // this.connectMQTT();
  },
  destroyed() {
    this.disconnectMQTT();
  },
  methods: {
    // async get_ip() {
    //   var url = "https://api.ipify.org/?format=json";
    //   await Repository.get(url)
    //     .then(response => {
    //       // console.log(response.data)
    //       this.ip = response.data.ip
    //     })
    //     .catch(error => ({ error: JSON.stringify(error) }))
    // },
    async get_ip() {
      var url = baseUrl + "?/IP/get/";
      await Repository.get(url)
        .then(response => {
          // console.log(response.data)
          if (response.data.error == 0) {
            this.ip = response.data.ip
          }
        })
        .catch(error => ({ error: JSON.stringify(error) }))
    },
    // get_ip() {
    //   this.ip = "123";
    // },
    async get_category() {
      var url = baseApi + "VideosFeed/get_category/";
      var headers = this.headersData;
      await Repository.get(url, { headers })
        .then(response => {
          if (response.data.error == 0) {
            this.categories = response.data.data;
          }
        })
        .catch(error => ({ error: JSON.stringify(error) }))
        .then(() => this.processing = false);
    },
    async get_section() {
      var url = baseApi + "VideosFeed/get_section/";
      var headers = this.headersData;
      await Repository.get(url, { headers })
        .then(response => {
          if (response.data.error == 0) {
            response.data.data.forEach(section => {
              this.videoSections.push({
                id: section.id,
                name: section.label,
                halfWidth: false,
              })
            });
          }
        })
        .catch(error => ({ error: JSON.stringify(error) }))
        .then(() => this.processing = false);
    },
    updateUserData(data = {}) {
      if (data.googleId) {
        localStorage.setItem("_userDataSIT_", JSON.stringify(data));
      } else {
        localStorage.removeItem("_userDataSIT_");
      }
      this.userData = data;
    },
    clickToSettings() {
      this.modal_settings = true;
    },
    updateSettings(c_all, c_13, c_20) {
      this.c_all = c_all
      this.c_13 = c_13;
      this.c_20 = c_20;
    },
    connectMQTT() {
      // console.log(mqtt) // for test
      if (this.connected) return false;
      let self = this;

      this.mqttClient = mqtt.connect(MQTT.HOST);
      this.mqttClient.on('connect', function () {
        self.connected = true;
        console.log(`Connected: %csuccessfully`, 'background: green; color: white');

        self.subscribeMQTT(`${MQTT.MTA}alert/#`);
        self.subscribeMQTT(`${MQTT.MTA}chat_room/#`);
        self.subscribeMQTT(`${MQTT.MTA}update_chat/#`);
        self.subscribeMQTT(`${MQTT.MTA}delete_chat/#`);

        if (self.$refs.router_view?.adjustLastCardHeight) {
          self.$refs.router_view.adjustLastCardHeight();
        }
      });
      this.mqttClient.on('close', () => {
        self.connected = false;
        console.log('Disconnected');
      });
      this.mqttClient.on('error', function (error) {
        self.connected = false;
        console.error(error);
      });
      this.mqttClient.on('message', function (topic, message) {
        // console.log(topic, message.toString());
        self.validateMQTT(topic, message.toString());
      });
    },
    disconnectMQTT() {
      if (this.connected) {
        this.mqttClient.end();
        this.subscribed = [];
      }
    },
    subscribeMQTT(topic) {
      const middle = topic.split('/')[1];
      if (this.mqttClient) {
        const i = this.subscribed.map((x) => x).indexOf(topic);
        if (i == -1) {
          this.subscribed.push(topic);
          this.mqttClient.subscribe(`${topic}`);
          console.log(`Topic: %c${isLocalhost ? topic : middle}`, 'background: green; color: white');
        } else {
          if (topic.startsWith(`${MQTT.MTA}chat_room/`)) {
            if (this.$refs.router_view?.handleGetNewMessage) {
              this.$refs.router_view.handleGetNewMessage();
            }
          }
          console.log(`Topic: %c${isLocalhost ? topic : middle}`, 'background: yellow; color: black');
        }
      } else {
        console.log(`Topic: %c${isLocalhost ? topic : middle}`, 'background: red; color: black');
      }
    },
    unsubscribeMQTT(topic) {
      const middle = topic.split('/')[1];
      if (this.mqttClient) {
        const i = this.subscribed.map((x) => x).indexOf(topic);
        if (i !== -1) {
          this.subscribed.splice(i, 1);
          this.mqttClient.unsubscribe(`${topic}`);
          console.log(`Topic: %c${isLocalhost ? topic : middle}`, 'background: orange; color: white');
        }
      }
    },
    publishMQTT(topic, payload) {
      this.mqttClient.publish(`${topic}`, `${payload}`);
    },
    validateMQTT(topic, message) {
      const topic_array = topic.split('/');
      let Mode = topic_array[1];
      let RoomID = topic_array[2] || null;
      let json = JSON.parse(message) || null;
      if (MQTT.SECRET !== json.secret) {
        return false;
      }
      if (Mode == "alert") {
        if (this.$refs.router_view?.handleAlert) {
          this.$refs.router_view.handleAlert(json);
        }
      } else if (Mode == "chat_room") {
        if (this.$refs.router_view?.handleGetNewMessage) {
          this.$refs.router_view.handleMessage(RoomID, json);
        }
      } else if (Mode == "update_chat") {
        if (this.$refs.router_view?.handleUpdateMessage) {
          this.$refs.router_view.handleUpdateMessage(RoomID, json);
        }
      } else if (Mode == "delete_chat") {
        if (this.$refs.router_view?.handleDeleteMessage) {
          this.$refs.router_view.handleDeleteMessage(RoomID, json);
        }
      }
    },
  },
}
</script>

<style>
.image-bordered {
  border: 2px solid #0034a1;
  padding: 2px;
  box-shadow: 0 0 0 2px #fff;
  border-radius: 50%;
}
</style>